const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

const fundConfigEndpoint = `${API_URL}/fund-config`;

export type FundConfigRequest = {
  tokens: string[];
  weights: number[];
  minDeposit?: number;
  fee?: number;
  exactWithdrawals?: boolean;
};

export type FundConfigResponse = {
  tokens: string[];
  token_factors: number[];
  fund_factor: number;
  royalty_factor: number;
  approximate_value: number;
  approximate_weights: number[];
  min_deposit_used: number;
};

export const fetchFundConfig = async (
  params: FundConfigRequest,
): Promise<FundConfigResponse> => {
  const body = {
    tokens: params.tokens,
    weights: params.weights,
    fee: params.fee ?? 0,
    exact_withdrawals: params.exactWithdrawals ?? true,
  };

  const res = await fetch(fundConfigEndpoint, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(
      `Fund config error: ${res.status} ${res.statusText} - ${errorText}`,
    );
  }

  return res.json();
};
